import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {List} from "immutable";
import {Observable} from "rxjs";
import {CountryCodesFetchService} from "./country-codes-fetch.service";

@Injectable()
export class CountryCodesResolver implements Resolve<Observable<string[]>> {

	constructor(private fetchService: CountryCodesFetchService) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<string[]> {
		return this.fetchService.fetchCountryCodes();
	}
}
